// src/services/userService.js

import { createHttpInstance, http } from "./httpService";
const edtechApiUrl =
  process.env.VUE_APP_EDTECH_API_URL ||
  "https://staging-surge-api.eddy4teachers.com";
const edtechHttp = createHttpInstance(`${edtechApiUrl}/api`);

edtechHttp.defaults.headers.common["X-API-KEY"] =
  process.env.VUE_APP_SURGE_API_KEY;

class LessonPackageService {
  async getAllGrades() {
    return await http.get("/grades");
  }

  async generateLessonPackage(email, data) {
    edtechHttp.defaults.headers.common["email"] = email;

    return await edtechHttp.post("/internal/lesson-packages/generate", data);
  }

  async buildLessonPackage(email, data) {
    edtechHttp.defaults.headers.common["email"] = email;

    return await edtechHttp.post("/internal/lesson-packages/build", data);
  }

  async getLessonPackage(email, id) {
    edtechHttp.defaults.headers.common["email"] = email;

    return await edtechHttp.get(`/internal/lesson-packages/${id}`);
  }

  async copySlideToDrive(email, id) {
    edtechHttp.defaults.headers.common["email"] = email;

    return await edtechHttp.get(`/internal/lesson-packages/${id}/copy`);
  }

  async getMyResources(email) {
    edtechHttp.defaults.headers.common["email"] = email;

    return await edtechHttp.get("/internal/lesson-packages/my-resources");
  }

  async updateLessonPackage(id, data) {
    return await http.put(`/edit/${id}`, data);
  }

  async getLessonPackageDownloads(id) {
    return await http.get(
      `/lesson-packages/download?lesson_package_id=${id}&resource_type=slides`
    );
  }
}

export default new LessonPackageService();
